module.exports = __webpack_public_path__ + "static/media/Chair1_Before.9a5c9fcf.jpg";